import React, { useRef, useState } from "react";
import {
  TextField,
  IconButton,
  InputAdornment,
  Tooltip
} from "@mui/material";
import { FileUploadOutlined } from "@mui/icons-material";

interface ImageUploadProps {
  label?: string;
  value?: File | null;
  onChange: (file: File | null) => void;
  maxSizeMB?: number;
  disabled?: boolean;
  helperText?: string;
  required?: boolean;
  customClassName?: string;
}

const DEFAULT_ACCEPTED_TYPES = ["image/png", "image/jpeg", "image/jpg", "application/pdf"];

const ImageUpload: React.FC<ImageUploadProps> = ({
  label = "",
  value,
  onChange,
  maxSizeMB = 2,
  disabled = false,
  helperText,
  required = false,
  customClassName,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [error, setError] = useState<string>("");

  const maxSizeBytes = maxSizeMB * 1024 * 1024;

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null;

    if (!file) {
      onChange(null);
      return;
    }

    if (!DEFAULT_ACCEPTED_TYPES.includes(file.type)) {
      setError("Formato invÃ¡lido. Use PNG, JPG ou JPEG.");
      onChange(null);
      return;
    }

    if (file.size > maxSizeBytes) {
      setError(`O arquivo deve ter no máximo ${maxSizeMB}MB.`);
      onChange(null);
      return;
    }

    setError("");
    onChange(file);
  };

  return (
    <div className="w-full">
      <input
        ref={inputRef}
        type="file"
        accept=".png,.jpg,.jpeg,.pdf"
        hidden
        onChange={handleFileChange}
        disabled={disabled}
      />

      <TextField
        size="small"
        variant="standard"
        fullWidth
        label={label}
        required={required}
        value={value?.name || ""}
        placeholder="Selecione um arquivo"
        error={!!error}
        helperText={error || helperText}
        disabled={disabled}
        onClick={() => inputRef.current?.click()}
        InputLabelProps={{
          shrink: true,
        }}
        InputProps={{
          readOnly: true,
          className: customClassName,
          disableUnderline: true,
          endAdornment: (
            <InputAdornment position="end">
              <Tooltip title="Selecionar arquivo">
                <IconButton
                  edge="end"
                  //onClick={() => /*inputRef.current?.click()*/}
                  disabled={disabled}
                >
                  <FileUploadOutlined sx={{ color: "#5A81FA" }} />
                </IconButton>
              </Tooltip>
            </InputAdornment>
          )
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            "& fieldset": {
              borderColor: "#5A81FA"
            },
            "&:hover fieldset": {
              borderColor: "#5A81FA"
            },
            "&.Mui-focused fieldset": {
              borderColor: "#5A81FA",
              borderWidth: "2px"
            }
          }
        }}
        className="cursor-pointer"
      />
    </div>
  );
};

export default ImageUpload;

